const ABLIST =[
    {
      id:'000011',
      nome:"CONOSCENZE TRIBU'",
      descrizione:'accesso alle conoscenze della propria tribu',
      costo:1,
      tipo:'Fisiche',
        prerequisiti:'nessuno',
        requisiti: 'nessuno',
        checked:false,
  },
    
  {id:'00001a',
  nome:"AMBIDESTRIA",
  descrizione:"Permette al giocatore di considerare entrambe le mani come dominanti (entrambe le mani possono quindi essere considerate valide per il trasporto, il combattimento e l'attivazione di abilità ed oggetti.",
  costo:1,
  tipo:'Fisiche',
    prerequisiti:'nessuno',
    requisiti: 'nessuno',
    checked:false,},
    
    {id:"00001b",
  nome:"ARCO/BALESTRA",
  descrizione:"Permette al giocatore l'utilizzo di archi e\o balestre.",
  costo:1,
  tipo:"Fisiche",
  prerequisiti:"nessuno",
  requisiti:"nessuno",
  checked:false,
  
  }, {id:'00001c',
  nome:'ARMATURE LEGGERE',
  descrizione:'Permette al giocatore di indossare le Armature appartenenti alla categoria Leggere',
  costo:1,
  tipo:'Fisiche',
    prerequisiti:'nessuno',
    requisiti: 'ARMATURE MEDIE',
    checked:false,},
  
  {id:'00001d',
  nome:"ARMATURE MEDIE",
  descrizione:'Permette al giocatore di indossare le Armature appartenenti alla categoria Medie',
  costo:1,
  tipo:'Fisiche',
    prerequisiti:'ARMATURE LEGGERE',
    requisiti: 'ARMATURE PESANTI',
    checked:false,},
    
  {id:'00001e',
  nome:'ARMATURE PESANTI',
  descrizione: 'Permette al giocatore di indossare le Armature appartenenti alla categoria Pesanti',
  costo:1,
  tipo:'Fisiche',
  prerequisiti:'ARMATURE MEDIE',
  requisiti: 'nessuno',
  checked:false,},
  
  {id:'00001f',
  nome:'SCUDO',
  descrizione: 'Permette al giocatore di utilizzare uno Scudo in battaglia',
  costo:1,
  tipo:'Fisiche',
  prerequisiti:'nessuno',
  requisiti: 'SCUDO TORRE',
  checked:false,
  }, 
  {id:'00001g',
  nome:'SCUDO TORRE',
  descrizione: 'Permette al giocatore di utilizzare uno Scudo Torre in battaglia',
  costo:1,
  tipo:'Fisiche',
  prerequisiti:'SCUDO',
  requisiti: 'nessuno',
  checked:false,
  },
  {id:'00001i',
  nome:'DURO A MORIRE',
  descrizione:"Permette al giocatore di rantolare e strisciare per la metà dei tempi di Coma",
  costo:1,
  tipo:'Fisiche',
  prerequisiti:'nessuno',
  requisiti: 'DURO A MORIRE',
  checked:false,},
  
  {id:'00001h',
  nome:'COSTITUZIONE TAURINA',
  descrizione: "Permette al giocatore di considerare i Pf aumentati di 1 in ogni locazione",
  costo:1,
  tipo:'Fisiche',
  prerequisiti:'DURO A MORIRE',
  requisiti: 'nessuno',
  checked:false,},
  
  {id:'00001l',
  nome:'FORZUTO',
  descrizione:"Permette al giocatore di considerarsi dotato di una forza superiore al normale, considera i suoi P.P. aumentati di 5, può trasportare più di una persona alla volta o una correndo",
  costo:1,
  tipo:'Fisiche',
  prerequisiti:'nessuno',
  requisiti: 'PIÙ FORTE',
  checked:false,},
  {id:'00001m',
  nome:'PIÙ FORTE',
  descrizione:"Permette al giocatore di eseguire La chiamata Crash con L'arma impugnata nella mano principale, la suddetta arma subisce lo stesso danno ",
  costo:1,
  tipo:'Fisiche',
  prerequisiti:'FORZUTO',
  requisiti: 'nessuno',
  checked:false,},
  {id:"00001n",
  nome:"DIVINCOLARSI",
  descrizione:" consente al giocatore di slegare i legacci che lo costringono, in maniera autonoma. NON PERMETTE IL LIBERARSI IN MANIERA AUTONOMA DA MANETTE O ALTRI MEZZI DI CONTENZIONE CON SERRATURE",
  costo:1,
  tipo:"Fisiche",
  prerequisiti:"nessuno",
  requisiti:"nessuno",
  checked:false,
  },
  
  {id:"00002a",
  nome:"MARCHIO DELL'ERINNI",
  descrizione:"Permette al giocatore di percepire il paradosso, in tutte le sue manifestazioni",
  costo:1,
  tipo:'Mentali',
  prerequisiti:'nessuno',
  requisiti: "ELETTO DALL'ERINNI",
  checked:false,},
  {
  id:'00002b',
  nome:"ELETTO DALL'ERINNI",
  descrizione:"Permette al giocatore di apprendere ed lanciare i poteri concessi da un Erinni",
  costo:1,
  tipo:'Mentali',
  prerequisiti:"MARCHIO DELL'ERINNI",
  requisiti: 'nessuno',
  checked:false,
  },
  {
  id:'00002c',
  nome:'CONOSCENZE METALLI',
  descrizione:"Permette al giocatore di considerarsi erudito relativamente a questa materia",
  costo:1,
  tipo:'Mentali',
  prerequisiti:'nessuno',
  requisiti: 'CRAFTING METALLI',
  checked:false,
  },
  {
  id:'00002d',
  nome:'CONOSCENZE ALCHIMIA',
  descrizione:"Permette al giocatore di considerarsi erudito relativamente a questa materia",
  costo:1,
  tipo:'Mentali',
  prerequisiti:'nessuno',
  requisiti: 'CRAFTING ALCHIMIA',
  checked:false,
  },
  {
  id:'00002e',
  nome:'CONOSCENZE ERBORISTERIA',
  descrizione:"Permette al giocatore di considerarsi erudito relativamente a questa materia",
  costo:1,
  tipo:'Mentali',
  prerequisiti:'nessuno',
  requisiti: ' nessuno',
  checked:false,
  },
  {
  id:'00002f',
  nome:'CONOSCENZE MITI E LEGGENDE',
  descrizione:"Permette al giocatore di considerarsi erudito relativamente a questa materia",
  costo:1,
  tipo:'Mentali',
  prerequisiti:'nessuno',
  requisiti: ' nessuno',
  checked:false,
  },
  {
  id:'00002g',
  nome:'CONOSCENZE LINGUE',
  descrizione:"Permette al giocatore di considerarsi erudito relativamente a questa materia",
  costo:1,
  tipo:'Mentali',
  prerequisiti:'nessuno',
  requisiti: ' nessuno',
  checked:false,
  },
  {
  id:'00002h',
  nome:'CONOSCENZE MEDICINA',
  descrizione:"Permette al giocatore di considerarsi erudito relativamente a questa materia",
  costo:1,
  tipo:'Mentali',
  prerequisiti:'PRIMO SOCCORSO',
  requisiti: 'nessuno',
  checked:false,
  },
  {
  id:'00002i',
  nome:'CRAFTING METALLI',
  descrizione:"Permette al giocatore di costruire oggetti di metallo",
  costo:1,
  tipo:'Mentali',
  prerequisiti: 'CONOSCENZE METALLI',
  requisiti: 'nessuno',
  checked:false,
  },
  {
  id:'00002l',
  nome:'CRAFTING ALCHIMIA',
  descrizione:"Permette al giocatore di produrre rimedi, veleni e droghe",
  costo:1,
  tipo:'Mentali',
  prerequisiti: 'CONOSCENZE ALCHIMIA',
  requisiti: 'nessuno',
  checked:false,
  },
  {
  id:'00002m',
  nome:'VALUTARE',
  descrizione:"Permette al giocatore di valutare il valore economico e la qualità di un oggetto",
  costo:1,
  tipo:'Mentali',
  prerequisiti: 'nessuno',
  requisiti: 'nessuno',
  checked:false,
  },{
  id:'00002n',
  nome:'SCASSINARE E DISATTIVARE',
  descrizione:"Permette al giocatore di scassinare serrature e disattivare trappole",
  costo:1,
  tipo:'Mentali',
  prerequisiti: 'nessuno',
  requisiti: 'nessuno',
  checked:false,
  },
  {
  id:'00002o',
  nome:"PRIMO SOCCORSO",
  descrizione:"Permette al giocatore di stabilizzare un soggetto in coma, il soggetto deve poter posizionare una benda sul corpo del bersaglio, mimando manovre salvavita.",
  costo:1,
  tipo:'Mentali',
  prerequisiti: "nessuno",
  requisiti: 'CONOSCENZA MEDICINA',
  checked:false,},
  {
  id:'00003a',
  nome:"CONOSCENZE GEOGRAFIA",
  descrizione:"Permette al giocatore di leggere i segnali ‘naturali', lasciati dagli altri trovatori",
  costo:1,
  tipo:'Sociali',
  prerequisiti: "nessuno",
  requisiti: 'nessuno',
  checked:false,},
  {
  id:'00003b',
  nome:"CORAGGIO",
  descrizione:"Permette al giocatore di dichiarare NO EFFETTO! alle chiamate PAURA!",
  costo:1,
  tipo:'Sociali',
  prerequisiti: "nessuno",
  requisiti: 'ARDITO',
  checked:false,},
  {
  id:'00003c',
  nome:"ARDITO",
  descrizione:"Permette al giocatore di dichiarare NO EFFETTO! alle chiamate TERRORE!",
  costo:1,
  tipo:'Sociali',
  prerequisiti: "CORAGGIO",
  requisiti: 'nessuno',
  checked:false,},
  {
  id:'00003d',
  nome:"PROVOCARE",
  descrizione:"Permette al giocatore di richiamare l'attenzione di un bersaglio",
  costo:1,
  tipo:'Sociali',
  prerequisiti: "nessuno",
  requisiti: 'nessuno',
  checked:false,},
  {
  id:'00003e',
  nome:"CERCARE",
  descrizione:"Permette al giocatore di visualizzare gli oggetti, anche nascosti in possesso del bersaglio.",
  costo:1,
  tipo:'Sociali',
  prerequisiti: "nessuno",
  requisiti: 'nessuno',
  checked:false,},
  
  
  {id:'00003f',
  nome:"INTERROGARE",
  descrizione:"Obbliga a dire la verità a un totale di domande pari ai P.F. del bersaglio.",
  costo:1,
  tipo:'Sociali',
  prerequisiti: "nessuno",
  requisiti: 'nessuno',
  checked:false,},
  
  {id:'00003g',
  nome:"INTIMIDIRE",
  descrizione:"Permette al giocatore di dichiarare la chiamata PAURA!.",
  costo:1,
  tipo:'Sociali',
  prerequisiti: "nessuno",
  requisiti: 'TERRORIZZARE',
  checked:false,},
  
  {id:'00003h',
  nome:"TERRORIZZARE",
  descrizione:"Permette al giocatore di dichiarare la chiamata TERRORE!.",
  costo:1,
  tipo:'Sociali',
  prerequisiti: "INTIMIDIRE",
  requisiti: 'nessuno',
  checked:false,},
  
  {id:'00003i',
  nome:"PROFUMO INTENSO",
  descrizione:"Il PG emana un forte odore pungente, qualunque azione costringa un'altro personaggio ad interagire in estrema prossimità del soggetto, vede tutte le tempistiche raddoppiate.",
  costo:1,
  tipo:'Sociali',
  prerequisiti: 'nessuno',
  requisiti: 'nessuno',
  checked:false,},
  
  {id:'00003l',
  nome:" AFFASCINARE",
  descrizione:"Permette al giocatore di dichiarare la chiamata CHARME! Su un bersaglio.",
  costo:1,
  tipo:'Sociali',
  prerequisiti: 'nessuno',
  requisiti: 'nessuno',
  checked:false,},
  
  {id:'00003m',
  nome:"REIETTO",
  descrizione:"Il PG è ai limiti della società, questo lo mette in contatto con i ceti malfamati di ogni popolo e di essere ignorato da quanti camminano lungo i vicoli e le strade di Avernum. Il PG, ottiene l'accesso ad alcune informazioni in anticipo rispetto al live e a un piccolo dono derivante dalla sua richiesta di carità.",
  costo:1,
  tipo:'Sociali',
  prerequisiti: 'nessuno',
  requisiti: 'nessuno',
  checked:false,},
  
  {id:'00003n',
  nome:"TASCA SEGRETA",
  descrizione:"Il giocatore può nascondere uno o più oggetti in un apposito contenitore indossato.",
  costo:1,
  tipo:'Sociali',
  prerequisiti: 'nessuno',
  requisiti: 'nessuno',
  checked:false,},
  
  {id:'00003o',
  nome:"PERFORMANCE",
  descrizione:"Il PG è riconosciuto ai più come BARDO, questo potrebbe garantirgli esibizioni e ingaggi in taverne e feste, inizia il live con un piccolo dono derivante dalla sua opera.",
  costo:1,
  tipo:'Sociali',
  prerequisiti: 'nessuno',
  requisiti: 'nessuno',
  checked:false,},
  
  {id:'00003p',
  nome:"GIOCATORE D'AZZARDO",
  descrizione: "Il PG è riconosciuto ai più come ABILE SCOMMETTITORE, questo potrebbe garantirgli l'accesso a tavoli e giocate in taverne e feste particolari, inizia il live con un piccolo dono derivante dalla sua opera.",
  costo:1,
  tipo:'Sociali',
  prerequisiti: 'nessuno',
  requisiti: 'nessuno',
  checked:false,},

  {id:'10001a',
  nome:"CUORE DELLA FORGIA",
  descrizione: "il giocatore quando impugna un arma da lui forgiata, può chiamare diretto sul primo attacco che compie durante una scena, qual'ora l'arma si dovesse rompere il giocatore subirebbe la compulsione mentale Ira!.",
  costo:1,
  tipo:'unica',
  prerequisiti: 'nessuno',
  requisiti: 'nessuno',
  checked:false,},

  {id:'10001b',
  nome:"VOCI DEL KEL",
  descrizione: "il giocatore subisce effetti ampliati dalla chiamata paura subendo l'effetto Terrore. Tutto ciò che ripara viene riparato nella metà del tempo.",
  costo:1,
  tipo:'unica',
  prerequisiti: 'nessuno',
  requisiti: 'nessuno',
  checked:false,},

  {id:'10001c',
  nome:"VENDICATORE",
  descrizione: "Ignora le cicatrici prodotte dagli attacchi dei Myrkhelt, subisce comunque il danno.",
  costo:1,
  tipo:'unica',
  prerequisiti: 'nessuno',
  requisiti: 'nessuno',
  checked:false},

  {id:'10001d',
  nome:"VERO BRENNITA",
  descrizione: "Una volta ad evento ignora un amputazione, subisce comunque il danno. Non può rifiutare sfide.",
  costo:1,
  tipo:'unica',
  prerequisiti: 'nessuno',
  requisiti: 'nessuno',
  checked:false},

  {id:'10001e',
  nome:"IMMOLARSI",
  descrizione: "Una volta ad evento può trasferire il danno da un bersaglio a se stesso entro 3 metri; ne subisce gli effetti raddoppiati dichiarando 'SONO IL TUO SCUDO!'",
  costo:1,
  tipo:'unica',
  prerequisiti: 'nessuno',
  requisiti: 'nessuno',
  checked:false},

  {id:'10001f',
  nome:"CONOSCENZA OCCULTA",
  descrizione: "Una volta per evento il giocatore può consumare un reagente floreale, per  non subire gli effetti di paradosso fino al medio. Tale azione produce la perdita istantanea del favore dell'Erinni.",
  costo:1,
  tipo:'unica',
  prerequisiti: 'nessuno',
  requisiti: 'nessuno',
  checked:false},

  {id:'10001g',
  nome:"FIGLIA DELLA FIAMMA",
  descrizione: "il PG è IMMUNE ALL’USTIONE ELEMENTALE FUOCO. Considera l’USTIONE ELEMENTARE GELO come USTIONE ELEMENTARE OSCURA GELO.",
  costo:1,
  tipo:'unica',
  prerequisiti: 'nessuno',
  requisiti: 'nessuno',
  checked:false},

  {id:'10001h',
  nome:"PLAGISTER",
  descrizione: "il pg considera raddoppiati i tempi connessi ai sintomi delle malattie, è considera dimezzati i tempi d’azione dei veleni.",
  costo:1,
  tipo:'unica',
  prerequisiti: 'nessuno',
  requisiti: 'nessuno',
  checked:false},

  {id:'10001h',
  nome:"ALI DI FARFALLA",
  descrizione: "Una volta sola per evento il PG può liberarsi da qualsiasi costrizione che limiti il movimento fisicamente",
  costo:1,
  tipo:'unica',
  prerequisiti: 'nessuno',
  requisiti: 'nessuno',
  checked:false},

  {id:'10001i',
  nome:"VOCATIO OCCULTA",
  descrizione: "Il Pg è favorito dagli Erinni, I patti con gli altri Erinni sembrebbero più facili,",
  costo:1,
  tipo:'unica',
  prerequisiti: 'nessuno',
  requisiti: 'nessuno',
  checked:false},

  {id:'10001m',
  nome:"PERSPICACIA",
  descrizione: "Una volta ad evento il PG può individuare se ciò che gli viene detto è vero, usando la chiamata 'E' QUESTA LA VERITA'?'",
  costo:1,
  tipo:'unica',
  prerequisiti: 'nessuno',
  requisiti: 'nessuno',
  checked:false},

  {id:'10001n',
  nome:"INFESTATO",
  descrizione: "Ad inizio live il giocatore a diritto ad alcune informazioni in più, dovute alla sua seconda mente...",
  costo:1,
  tipo:'unica',
  prerequisiti: 'nessuno',
  requisiti: 'nessuno',
  checked:false},

  {id:'10001o',
  nome:"IRACONDO",
  descrizione: "Una volta ad evento quando in preda all’ira, ignora gli effetti degli status (ad esclusione di coma), dichiarando 'SONO INARRESTABILE!'",
  costo:1,
  tipo:'unica',
  prerequisiti: 'nessuno',
  requisiti: 'nessuno',
  checked:false},

  {id:'10001p',
  nome:"FUGGIGUAI",
  descrizione: "Una volta ad evento può perquisire senza dover contare il tempo necessario",
  costo:1,
  tipo:'unica',
  prerequisiti: 'nessuno',
  requisiti: 'nessuno',
  checked:false},

  {id:'10001q',
  nome:"SENZASOGNI",
  descrizione: "Una volta ad evento il PG può dichiarare NO EFFETTO ad una compulsione mentale che lo farebbe addormentare",
  costo:1,
  tipo:'unica',
  prerequisiti: 'nessuno',
  requisiti: 'nessuno',
  checked:false},

  {id:'10001r',
  nome:"SPEZZASIGILLI",
  descrizione: "Una volta ad evento il PG può dichiarare CRASH! al fine di rompere uno scudo, per farlo deve impugnare un arma da lui stesso forgiata",
  costo:1,
  tipo:'unica',
  prerequisiti: 'nessuno',
  requisiti: 'nessuno',
  checked:false},

  {id:'10001s',
  nome:"SPEZZAINCUBI",
  descrizione: "il PG può chiamare NO EFFETTO alle compulsioni mentali operate degli spiriti, quando lo fa diviene immediatamente il bersaglio dello spirito!",
  costo:1,
  tipo:'unica',
  prerequisiti: 'nessuno',
  requisiti: 'nessuno',
  checked:false},

  {id:'10001t',
  nome:"RIBELLE",
  descrizione: "il PG può chiamare NO EFFETTO ai rituali d'OBLIVION!",
  costo:1,
  tipo:'unica',
  prerequisiti: 'nessuno',
  requisiti: 'nessuno',
  checked:false},

  {id:'10001u',
  nome:"SANGUE FREDDO",
  descrizione: "una volta per evento il PG può chiamare NO EFFETTO a PAURA!",
  costo:1,
  tipo:'unica',
  prerequisiti: 'nessuno',
  requisiti: 'nessuno',
  checked:false},

  {id:'10001v',
  nome:"PORTA INCUBI",
  descrizione: "Gli spiriti non l'attaccano volontariamente, ma gli effetti delle loro compulsioni mentali sono raddoppiati nel tempo",
  costo:1,
  tipo:'unica',
  prerequisiti: 'nessuno',
  requisiti: 'nessuno',
  checked:false},

  {id:'10001z',
  nome:"FORGIASPIRITI",
  descrizione: "Il PG una volta per evento può chiamare Crash su un oggetto,arma o armatura che abbia egli stesso forgiato, il Pg cosi facendo subisce FATAL!, i PG nel raggio di 3 mentri da lui divengono immuni alla paura",
  costo:1,
  tipo:'unica',
  prerequisiti: 'nessuno',
  requisiti: 'nessuno',
  checked:false},

  {id:'10002a',
  nome:"POSSEDUTO",
  descrizione: "Il PG può chiamare No EFFETTO alle COMPULSIONI MENTALI, ma considera gli attacchi degli spiriti sempre come Diretto!",
  costo:1,
  tipo:'unica',
  prerequisiti: 'nessuno',
  requisiti: 'nessuno',
  checked:false},

  {id:'10002b',
  nome:"SESTO SENSO",
  descrizione: "Una volta per evento il pg può avvertire la presenza di un pericolo invisibile o nascosto",
  costo:1,
  tipo:'unica',
  prerequisiti: 'nessuno',
  requisiti: 'nessuno',
  checked:false},

  {id:'10002c',
  nome:"GUARDIANO",
  descrizione: "Il pg è resistente alle compulsioni mentali naturali",
  costo:1,
  tipo:'unica',
  prerequisiti: 'nessuno',
  requisiti: 'nessuno',
  checked:false},

  {id:'10002d',
  nome:"DANZATRICE DEL FLUSSO",
  descrizione: "in attesa...",
  costo:1,
  tipo:'unica',
  prerequisiti: 'nessuno',
  requisiti: 'nessuno',
  checked:false},

  {id:'10002e',
  nome:"CERCATORE D’ACQUA",
  descrizione: "Il Pg non soffre le penalità della sete, resistente ad alcuni veleni",
  costo:1,
  tipo:'unica',
  prerequisiti: 'nessuno',
  requisiti: 'nessuno',
  checked:false},

  {id:'10002f',
  nome:"GIURAMENTO DEL CENSORE",
  descrizione: "Il PG può mentire alla prima domanda dell'abilità interrogare, ma perde ugualmente il suo pf",
  costo:1,
  tipo:'unica',
  prerequisiti: 'nessuno',
  requisiti: 'nessuno',
  checked:false},

  {id:'10002g',
  nome:"OSSERVATORE DELL’ABISSO",
  descrizione: "Il PG può considerare il TERRORE semplice PAURA, ma è suscttibile al mondo dei sogni",
  costo:1,
  tipo:'unica',
  prerequisiti: 'nessuno',
  requisiti: 'nessuno',
  checked:false},

  {id:'10002h',
  nome:"MIGLIORIE ANATOMICHE",
  descrizione: "Il PG è in grado i costruirsi e impiantarsi protesi, tali protesi vanno concordate con la masterizzazione per pregi e difetti",
  costo:1,
  tipo:'unica',
  prerequisiti: 'nessuno',
  requisiti: 'nessuno',
  checked:false},

  {id:'10002i',
  nome:"MNEMONIC",
  descrizione: "Il PG ha accesso ad alcuni cartellini ricodo speciali",
  costo:1,
  tipo:'unica',
  prerequisiti: 'nessuno',
  requisiti: 'nessuno',
  checked:false},
  
  {id:'10002l',
  nome:"GUARDIANO DELLA PORTA",
  descrizione: "Il PG una volta ad evento può ignorare un reagente alchemico di cui ha bisogno, per una sua preparazione",
  costo:1,
  tipo:'unica',
  prerequisiti: 'nessuno',
  requisiti: 'nessuno',
  checked:false},

  {id:'10002m',
  nome:"GERMOFOBICA",
  descrizione: "Il Pg è immune alle malattia Infezione finche indossa la maschera, se per qualche raggione la leva o subisce una qualsiasi forma di malattia, subisce immediatamente lo status PAURA! ",
  costo:1,
  tipo:'unica',
  prerequisiti: 'nessuno',
  requisiti: 'nessuno',
  checked:false},

  {id:'10002n',
  nome:"VOCE DELL’ERINNI",
  descrizione: "Il pg abbassa di uno il livello del paradosso durante un rituale al quale partecipa, unica occasione nel quale può parlare liberamente.",
  costo:1,
  tipo:'unica',
  prerequisiti: 'nessuno',
  requisiti: 'nessuno',
  checked:false},

  {id:'10002o',
  nome:"DANZATRICE DEL FLUSSO",
  descrizione: "Il pg è ingrado di castare l'incantesimo pari e dispari dell'arcano del fato. quando lo fa il pg non è più in grado di castare per 10 minuti",
  costo:1,
  tipo:'unica',
  prerequisiti: 'nessuno',
  requisiti: 'nessuno',
  checked:false},

  {id:'10002p',
  nome:"GIUDICE",
  descrizione: "Il PG, una volta ad evento,  può sostituire un reagente alchemico con un altro in suo posesso",
  costo:1,
  tipo:'unica',
  prerequisiti: 'nessuno',
  requisiti: 'nessuno',
  checked:false},

  {id:'10002q',
  nome:"FABBRO FORTUNATO",
  descrizione: "Il PG, una volta ad evento,  può non considerare uno dei materiali necessari per una lavorazione",
  costo:1,
  tipo:'unica',
  prerequisiti: 'nessuno',
  requisiti: 'nessuno',
  checked:false},

  {id:'10002r',
  nome:"PAROLE MELLIFLUE",
  descrizione: "Il pg può mentire alla prima domanda che gli viene posta con l'abilità interrogare, PERDENDO NORMALMENTE IL SUO PF, quando mente però il pg ottiene lo status DEBOLEZZA",
  costo:1,
  tipo:'unica',
  prerequisiti: 'nessuno',
  requisiti: 'nessuno',
  checked:false},
]



  
  const ABLIST1 =[
    
    
    {id:'00001a',
        nome:"AMBIDESTRIA",
    descrizione:"Permette al giocatore di considerare entrambe le mani come dominanti (entrambe le mani possono quindi essere considerate valide per il trasporto, il combattimento e l'attivazione di abilità ed oggetti.",
        costo:1,
        tipo:'Fisiche',
          prerequisiti:'nessuno',
          requisiti: 'nessuno',
          checked:false,},
          
          {id:"00001b",
    nome:"ARCO/BALESTRA",
    descrizione:"Permette al giocatore l'utilizzo di archi e\o balestre.",
    costo:1,
    tipo:"Fisiche",
    prerequisiti:"nessuno",
    requisiti:"nessuno",
    checked:false,
  
    }, {id:'00001c',
        nome:'ARMATURE LEGGERE',
        descrizione:'Permette al giocatore di indossare le Armature appartenenti alla categoria Leggere',
        costo:1,
        tipo:'Fisiche',
          prerequisiti:'nessuno',
          requisiti: 'ARMATURE MEDIE',
          checked:false,},
  
      {id:'00001d',
        nome:"ARMATURE MEDIE",
        descrizione:'Permette al giocatore di indossare le Armature appartenenti alla categoria Medie',
        costo:1,
        tipo:'Fisiche',
          prerequisiti:'ARMATURE LEGGERE',
          requisiti: 'ARMATURE PESANTI',
          checked:false,},
          
      {id:'00001e',
      nome:'ARMATURE PESANTI',
      descrizione: 'Permette al giocatore di indossare le Armature appartenenti alla categoria Pesanti',
      costo:1,
      tipo:'Fisiche',
        prerequisiti:'ARMATURE MEDIE',
        requisiti: 'nessuno',
        checked:false,},
        
      {id:'00001f',
      nome:'SCUDO',
      descrizione: 'Permette al giocatore di utilizzare uno Scudo in battaglia',
      costo:1,
      tipo:'Fisiche',
        prerequisiti:'nessuno',
        requisiti: 'SCUDO TORRE',
        checked:false,
    }, 
    {id:'00001g',
      nome:'SCUDO TORRE',
      descrizione: 'Permette al giocatore di utilizzare uno Scudo Torre in battaglia',
      costo:1,
      tipo:'Fisiche',
        prerequisiti:'SCUDO',
        requisiti: 'nessuno',
        checked:false,
    },
    {id:'00001i',
    nome:'DURO A MORIRE',
    descrizione:"Permette al giocatore di rantolare e strisciare per la metà dei tempi di Coma",
    costo:1,
    tipo:'Fisiche',
    prerequisiti:'nessuno',
    requisiti: 'DURO A MORIRE',
    checked:false,},
    
    {id:'00001h',
    nome:'COSTITUZIONE TAURINA',
    descrizione: "Permette al giocatore di considerare i Pf aumentati di 1 in ogni locazione",
    costo:1,
    tipo:'Fisiche',
    prerequisiti:'DURO A MORIRE',
    requisiti: 'nessuno',
    checked:false,},
  
    {id:'00001l',
      nome:'FORZUTO',
      descrizione:"Permette al giocatore di considerarsi dotato di una forza superiore al normale, considera i suoi P.P. aumentati di 5, può trasportare più di una persona alla volta o una correndo",
      costo:1,
      tipo:'Fisiche',
        prerequisiti:'nessuno',
        requisiti: 'PIÙ FORTE',
        checked:false,},
    {id:'00001m',
      nome:'PIÙ FORTE',
      descrizione:"Permette al giocatore di eseguire La chiamata Crash con L'arma impugnata nella mano principale, la suddetta arma subisce lo stesso danno ",
      costo:1,
      tipo:'Fisiche',
        prerequisiti:'FORZUTO',
        requisiti: 'nessuno',
        checked:false,},
    {id:"00001n",
    nome:"DIVINCOLARSI",
    descrizione:" consente al giocatore di slegare i legacci che lo costringono, in maniera autonoma. NON PERMETTE IL LIBERARSI IN MANIERA AUTONOMA DA MANETTE O ALTRI MEZZI DI CONTENZIONE CON SERRATURE",
    costo:1,
    tipo:"Fisiche",
    prerequisiti:"nessuno",
    requisiti:"nessuno",
    checked:false,
    },
    
    {id:"00002a",
    nome:"MARCHIO DELL'ERINNI",
      descrizione:"Permette al giocatore di percepire il paradosso, in tutte le sue manifestazioni",
      costo:1,
      tipo:'Mentali',
        prerequisiti:'nessuno',
        requisiti: "ELETTO DALL'ERINNI",
        checked:false,},
    {
      id:'00002b',
      nome:"ELETTO DALL'ERINNI",
      descrizione:"Permette al giocatore di apprendere ed lanciare i poteri concessi da un Erinni",
      costo:1,
      tipo:'Mentali',
        prerequisiti:"MARCHIO DELL'ERINNI",
        requisiti: 'nessuno',
        checked:false,
    },
    {
      id:'00002c',
      nome:'CONOSCENZE METALLI',
      descrizione:"Permette al giocatore di considerarsi erudito relativamente a questa materia",
      costo:1,
      tipo:'Mentali',
        prerequisiti:'nessuno',
        requisiti: 'CRAFTING METALLI',
        checked:false,
    },
    {
      id:'00002d',
      nome:'CONOSCENZE ALCHIMIA',
      descrizione:"Permette al giocatore di considerarsi erudito relativamente a questa materia",
      costo:1,
      tipo:'Mentali',
        prerequisiti:'nessuno',
        requisiti: 'CRAFTING ALCHIMIA',
        checked:false,
    },
    {
      id:'00002e',
      nome:'CONOSCENZE ERBORISTERIA',
      descrizione:"Permette al giocatore di considerarsi erudito relativamente a questa materia",
      costo:1,
      tipo:'Mentali',
        prerequisiti:'nessuno',
        requisiti: 'nessuno',
        checked:false,
    },
    {
      id:'00002f',
      nome:'CONOSCENZE MITI E LEGGENDE',
      descrizione:"Permette al giocatore di considerarsi erudito relativamente a questa materia",
      costo:1,
      tipo:'Mentali',
        prerequisiti:'nessuno',
        requisiti: 'nessuno',
        checked:false,
    },
    {
      id:'00002g',
      nome:'CONOSCENZE LINGUE',
      descrizione:"Permette al giocatore di considerarsi erudito relativamente a questa materia",
      costo:1,
      tipo:'Mentali',
        prerequisiti:'nessuno',
        requisiti: 'nessuno',
        checked:false,
    },
    {
      id:'00002h',
      nome:'CONOSCENZE MEDICINA',
      descrizione:"Permette al giocatore di considerarsi erudito relativamente a questa materia",
      costo:1,
      tipo:'Mentali',
        prerequisiti:'PRIMO SOCCORSO',
        requisiti: 'nessuno',
        checked:false,
    },
    {
      id:'00002i',
      nome:'CRAFTING METALLI',
      descrizione:"Permette al giocatore di costruire oggetti di metallo",
      costo:1,
      tipo:'Mentali',
        prerequisiti: 'CONOSCENZE METALLI',
        requisiti: 'nessuno',
        checked:false,
    },
    {
      id:'00002l',
      nome:'CRAFTING ALCHIMIA',
      descrizione:"Permette al giocatore di produrre rimedi, veleni e droghe",
      costo:1,
      tipo:'Mentali',
        prerequisiti: 'CONOSCENZE ALCHIMIA',
        requisiti: 'nessuno',
        checked:false,
    },
    {
      id:'00002m',
      nome:'VALUTARE',
      descrizione:"Permette al giocatore di valutare il valore economico e la qualità di un oggetto",
      costo:1,
      tipo:'Mentali',
        prerequisiti: 'nessuno',
        requisiti: 'nessuno',
        checked:false,
    },{
      id:'00002n',
      nome:'SCASSINARE E DISATTIVARE',
      descrizione:"Permette al giocatore di scassinare serrature e disattivare trappole",
      costo:1,
      tipo:'Mentali',
        prerequisiti: 'nessuno',
        requisiti: 'nessuno',
        checked:false,
    },
    {
      id:'00002o',
      nome:"PRIMO SOCCORSO",
      descrizione:"Permette al giocatore di stabilizzare un soggetto in coma, il soggetto deve poter posizionare una benda sul corpo del bersaglio, mimando manovre salvavita.",
      costo:1,
      tipo:'Mentali',
        prerequisiti: "nessuno",
        requisiti: 'CONOSCENZA MEDICINA',
        checked:false,},
    {
      id:'00003a',
      nome:"CONOSCENZE GEOGRAFIA",
      descrizione:"Permette al giocatore di leggere i segnali 'naturali', lasciati dagli altri trovatori",
      costo:1,
      tipo:'Sociali',
        prerequisiti: "nessuno",
        requisiti: 'nessuno',
        checked:false,},
    {
      id:'00003b',
      nome:"CORAGGIO",
      descrizione:"Permette al giocatore di dichiarare NO EFFETTO! alle chiamate PAURA!",
      costo:1,
      tipo:'Sociali',
        prerequisiti: "nessuno",
        requisiti: 'ARDITO',
        checked:false,},
    {
      id:'00003c',
      nome:"ARDITO",
      descrizione:"Permette al giocatore di dichiarare NO EFFETTO! alle chiamate TERRORE!",
      costo:1,
      tipo:'Sociali',
        prerequisiti: "CORAGGIO",
        requisiti: 'nessuno',
        checked:false,},
    {
      id:'00003d',
      nome:"PROVOCARE",
      descrizione:"Permette al giocatore di richiamare l'attenzione di un bersaglio",
      costo:1,
      tipo:'Sociali',
        prerequisiti: "nessuno",
        requisiti: 'nessuno',
        checked:false,},
    {
      id:'00003e',
      nome:"CERCARE",
      descrizione:"Permette al giocatore di visualizzare gli oggetti, anche nascosti in possesso del bersaglio.",
      costo:1,
      tipo:'Sociali',
        prerequisiti: "nessuno",
        requisiti: 'nessuno',
        checked:false,},
    
    
      {id:'00003f',
      nome:"INTERROGARE",
      descrizione:"Obbliga a dire la verità a un totale di domande pari ai P.F. del bersaglio.",
      costo:1,
      tipo:'Sociali',
        prerequisiti: "nessuno",
        requisiti: 'nessuno',
        checked:false,},
    
    {id:'00003g',
      nome:"INTIMIDIRE",
      descrizione:"Permette al giocatore di dichiarare la chiamata PAURA!.",
      costo:1,
      tipo:'Sociali',
        prerequisiti: "nessuno",
        requisiti: 'TERRORIZZARE',
        checked:false,},
    
    {id:'00003h',
      nome:"TERRORIZZARE",
      descrizione:"Permette al giocatore di dichiarare la chiamata TERRORE!.",
      costo:1,
      tipo:'Sociali',
        prerequisiti: "INTIMIDIRE",
        requisiti: 'nessuno',
        checked:false,},
    
    {id:'00003i',
      nome:"PROFUMO INTENSO",
      descrizione:"Il PG emana un forte odore pungente, qualunque azione costringa un'altro personaggio ad interagire in estrema prossimità del soggetto, vede tutte le tempistiche raddoppiate.",
      costo:1,
      tipo:'Sociali',
        prerequisiti: 'nessuno',
        requisiti: 'nessuno',
        checked:false,},
    
    {id:'00003l',
      nome:" AFFASCINARE",
      descrizione:"Permette al giocatore di dichiarare la chiamata CHARME! Su un bersaglio.",
      costo:1,
      tipo:'Sociali',
        prerequisiti: 'nessuno',
        requisiti: 'nessuno',
        checked:false,},
    
    {id:'00003m',
      nome:"REIETTO",
      descrizione:"Il PG è ai limiti della società, questo lo mette in contatto con i ceti malfamati di ogni popolo e di essere ignorato da quanti camminano lungo i vicoli e le strade di Avernum. Il PG, ottiene l'accesso ad alcune informazioni in anticipo rispetto al live e a un piccolo dono derivante dalla sua richiesta di carità.",
      costo:1,
      tipo:'Sociali',
        prerequisiti: 'nessuno',
        requisiti: 'nessuno',
        checked:false,},
    
    {id:'00003n',
      nome:"TASCA SEGRETA",
      descrizione:"Il giocatore può nascondere uno o più oggetti in un apposito contenitore indossato.",
      costo:1,
      tipo:'Sociali',
        prerequisiti: 'nessuno',
        requisiti: 'nessuno',
        checked:false,},
    
    {id:'00003o',
      nome:"PERFORMANCE",
      descrizione:"Il PG è riconosciuto ai più come BARDO, questo potrebbe garantirgli esibizioni e ingaggi in taverne e feste, inizia il live con un piccolo dono derivante dalla sua opera.",
      costo:1,
      tipo:'Sociali',
        prerequisiti: 'nessuno',
        requisiti: 'nessuno',
        checked:false,},
    
    {id:'00003p',
      nome:"GIOCATORE D'AZZARDO",
      descrizione: "Il PG è riconosciuto ai più come ABILE SCOMMETTITORE, questo potrebbe garantirgli l'accesso a tavoli e giocate in taverne e feste particolari, inizia il live con un piccolo dono derivante dalla sua opera.",
      costo:1,
      tipo:'Sociali',
        prerequisiti: 'nessuno',
        requisiti: 'nessuno',
        checked:false,}
      ]
  
  export {ABLIST, ABLIST1};